<template>
  <div class="box9">
    <div class="page-title">
      <p>10年+经验实战专家主导研发和设计</p>
      助你掌握每一个技术点
    </div>
<div class="subTitle">作为博学谷战略级高阶课项目，整合集团实力资源，培养架构思维</div>
    <div class="teacher-box">
      <div class="teacher-con">
        <div
          class="teacher"
          v-for="(item, index) in teacherList"
          :key="index"
          :style="
            `backgroundImage: url(` +
            require(`../../../assets/coursePage/architect/box9/${
              index + 1
            }.png`) +
            `)`
          "
          @click="changeCur(index)"
        >
          <div class="tName">{{ item.name }}</div>
          <p v-html="item.p"></p>
        </div>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '8.973333rem' }"
    >
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ teacherList[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in teacherList[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in teacherList[cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "王",
          tag: ["山东大学计算机硕士", "10年以上项目开发经验"],
          p: "山东大学计算机硕士<br />10年以上项目开发经验",
          info: [
            "主持开发过的项目涉及银行、政府等应用领域；",
            "专注自然语言处理NLP、计算机视觉CV等深度学习领域研究；",
            "多年企业内训培训师，讲课深入浅出，深受学生和企业员工的好评。",
          ],
        },
        {
          name: "原",
          tag: ["北京大学工学硕士", "人工智能领域技术大佬"],
          p: "北京大学工学硕士<br />人工智能领域技术大佬",
          info: [
            "曾主导参与新浪微博、中新网等多个重要项目；",
            "在多家互联网公司担任数据科学家，对Pytorch、Tensorflow、Hadoop、Spark等大数据、人工智能技术有多年企业实践经验。",
          ],
        },
        {
          name: "赵",
          p: "人工智能领域技术大佬",
          tag: ["人工智能领域技术大佬"],
          info: [
            "曾任职美团搜索部，负责NER及Bert搜索排序优化；",
            "多年模式识别和数据挖掘开发经验，主导研发多项科研项目；",
            "曾负责信贷风控模型和智能医疗数据平台开发，专注ML/DL/PR/KG领域相关算法的应用；",
            "对Hadoop、SparkTensorflow和Pytorch等大数据、人工智能技术有多年企业实践经验。",
          ],
        },
        {
          name: "姚",
          p: "哈尔滨工程大学硕士<br />GIS行业工程实战大佬",
          tag: ["哈尔滨工程大学硕士", "GIS行业工程实战大佬"],
          info: [
            "在图像分割、检测、追踪等方面有多年从业经历；",
            "曾参与多项重大项目，具备丰富的工程落地经验；",
            "对Tensorflow和Pytorch有丰富的使用经验，对于二维和三维图像方面有深入了解。",
          ],
        },
        {
          name: "李",
          p: "精通大数据挖掘和计算机<br />视觉方向",
          tag: ["某大学硕士", "大数据挖掘和计算机视觉方向"],
          info: [
            "曾主持和参与了多家互联网企业基于海量数据的用户画像、推荐系统及人脸支付相关项目；",
            "对大数据领域中的常用框架Hadoop、Hive、Spark等有丰富的实战经验和深入的研究，具有多年人工智能和大数据开发经验。",
          ],
        },
        {
          name: "朱",
          p: "多年机器学习与人工智能相<br />关领域算法分析研发经验",
          tag: ["985硕士"],
          info: [
            "多年机器学习与人工智能领域算法分析研发经验；",
            "前百度人工智能大佬；",
            "熟悉C++、Python语言，深谙框架Tensorflow、Pytorch；",
            "对机器学习、自然语言处理相关理论和工程实践有深入研究；",
            "对知识图谱、文本纠错等有丰富的项目经验。",
          ],
        },
      ],
      teacherList: [
        {
          name: "潜心老师",
          p: "13年研发经验丨前某大厂架构师丨电商中台项目资深架构师",
          tag: ["13年研发经验", "前某大厂架构师", "电商中台项目资深架构师"],
          info: [
            "主导完成⽀付中⼼、营销中⼼、供应链平台等多个系统的架构与研发；",
            "⻓期担任企业核心架构师职务，对在线教育、互联⽹⾦融、电⼦商务等领域有着丰富的系统架构经验；",
            "授课风格沉稳严谨，擅长结合企业项目，分步引导深入思考。",
          ],
        },
        {
          name: "唐僧老师",
          p: "10+年Java架构设计与研发丨⼤⼚⾯试",
          tag: ["10+年Java架构设计与研发", "⼤⼚⾯试"],
          info: [
            "项⽬覆盖电商、⾦融、办公⾃动化、在线教育等；",
            "精通Java 钻研⼤⼚⾯试算法多年、有着丰富的算法⾯经；",
            "在⼤数据、物联⽹等⽅⾯也有着深⼊的研究；",
            "讲课时善用生活中的例子，贴切生动，使得复杂知识点通俗易懂。",
          ],
        },
        {
          name: "子慕老师",
          p: "架构设计丨分布式丨微服务丨⾼可⽤",
          tag: ["架构设计", "分布式", "微服务", "⾼可⽤"],
          info: [
            "某⾦融公司担任架构师；",
            "在系统架构设计、分布式、微服务、⾼可⽤等技术架构具有丰富的实战经验；",
            "对源码有较深的研究，专注于架构设计、研发以及解决⽅案的研究。",
          ],
        },
        // {
        //   name: "虚竹老师",
        //   p: "10年研发经验<br />⼤⼚资深架构师",
        //   tag: ["10年研发经验", "⼤⼚资深架构师"],
        //   info: [
        //     "10年研发经验，曾就任某⼤⼚资深架构师之职；",
        //     "主导研发项⽬涉及保险、⼟⽊、电商、咨询、医疗、教育等多领域；",
        //     "在⼤数据⽅⾯也有深⼊的研究；",
        //     "针对开源框架、中间件、分布式缓存、微服务、⾼并发等技术有深⼊的研究；",
        //     "讲课细致入微，不放过任意一个小细节，知识全面而实用。",
        //   ],
        // },
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box9 {
  padding: 80px 0 58px;

  width: 100%;
  background: #f5f9ff;

  .page-title {
  
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    line-height: 62px;
    letter-spacing: 0px;
    color: #24375c;
  }
 .subTitle{
 margin: 29px 0 49px;
   	font-family: PingFangSC-Regular;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #24375c;
  text-align: center;
 }
  .word {
    white-space: nowrap;
  }

  .teacher-box {
    overflow: auto;
    margin: 0 auto;
    // width: 654px;
    .teacher-con {
      padding: 0 36px;
      width: 1000px;
      display: flex;
      justify-content: space-between;
    }
    .teacher {
      margin-bottom: 30px;
      padding-left: 17px;
      width: 310px;
      height: 392px;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 20px;
      box-sizing: border-box;
      color: #fff;
      .tName {
        margin-top: 280px;
        font-family: PingFangSC-Medium;
        font-size: 26px;
        font-weight: 500;
        letter-spacing: 0px;
        color: #ffffff;
      }
      p {
        margin-top: 4px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;
    height: 628px;
    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      margin-bottom: 15px;
      padding: 0px 16px;
      height: 44px;
      border-radius: 8px;
      text-align: center;
      color: #00b39b;
      line-height: 44px;
      box-sizing: border-box;
      background-color: rgba(0, 230, 200, 0.15);
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 24px;
    }

    .tag2 {
      color: #3388ff;

      background-color: rgba(51, 136, 255, 0.15);
    }

    .tag3 {
      color: #ff5622;
      background-color: rgba(255, 86, 34, 0.15);
      // background: #ff5622;
    }

    .tag4 {
      color: #ff0093;
      background-color: rgba(255, 0, 147, 0.15);
      // background: #ff5622;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
